export function dateToUnixTimestamp(dateString) {
  const date = new Date(dateString);
  return date.getTime();
}

export function unixTimestampToDate(timestamp) {
  // Convert Unix timestamp to milliseconds
  const date = new Date(timestamp);

  // Get the components of the date
  let day = date.getDate();
  let month = date.getMonth() + 1; // JS months are zero-based
  const year = date.getFullYear();

  // Pad the day and month with leading zeros if necessary
  day = day < 10 ? `0${day}` : day;
  month = month < 10 ? `0${month}` : month;

  // Format the date in MM/DD/YYYY format
  return `${month}/${day}/${year}`;
}
